module.exports = __webpack_public_path__ + "static/media/tesla.ec8a9c73.svg";